import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  background?: 'cream' | 'white' | 'beige';
  id?: string;
}
export function Section({
  children,
  className = '',
  background = 'cream',
  id
}: SectionProps) {
  const bgColors = {
    cream: 'bg-[#FAF7F2]',
    white: 'bg-white',
    beige: 'bg-[#E8DCC4]'
  };
  return <section id={id} className={`${bgColors[background]} py-12 md:py-20 px-6 ${className}`} data-id="element-100">
      <div className="max-w-3xl mx-auto" data-id="element-101">{children}</div>
    </section>;
}